export const conductorTheme = {
  surface: 'var(--od-c-ffffff, #ffffff)',
  surfaceSoft: 'var(--od-c-f8fafc, #f8fafc)',
  surfaceSubtle: 'var(--od-c-f9fafb, #f9fafb)',
  surfaceMuted: 'var(--od-c-f3f4f6, #f3f4f6)',
  surfaceInset: 'var(--od-c-fafafa, #fafafa)',
  divider: 'var(--od-c-f0f0f0, #f0f0f0)',
  border: 'var(--od-c-e5e7eb, #e5e7eb)',
  borderStrong: 'var(--od-c-d1d5db, #d1d5db)',
  borderMuted: 'var(--od-c-cbd5e1, #cbd5e1)',
  borderBlue: 'var(--od-c-dbe4ef, #dbe4ef)',
  borderBlueStrong: 'var(--od-c-bfdbfe, #bfdbfe)',
  text: 'var(--od-c-111827, #111827)',
  textStrong: 'var(--od-c-1f2937, #1f2937)',
  textBody: 'var(--od-c-374151, #374151)',
  textSlate: 'var(--od-c-334155, #334155)',
  textSoft: 'var(--od-c-475569, #475569)',
  textMuted: 'var(--od-c-64748b, #64748b)',
  textFaint: 'var(--od-c-6b7280, #6b7280)',
  textSubtle: 'var(--od-c-9ca3af, #9ca3af)',
  iconMuted: 'var(--od-c-94a3b8, #94a3b8)',
  accentSurface: 'var(--od-c-eff6ff, #eff6ff)',
  accentSurfaceStrong: 'var(--od-c-e8f0fe, #e8f0fe)',
  accentSurfaceMuted: 'var(--od-c-e8f1f8, #e8f1f8)',
  accentSurfaceSoft: 'var(--od-c-f0f8fd, #f0f8fd)',
  accentBorder: 'var(--od-c-b7d9ef, #b7d9ef)',
  accentText: 'var(--od-c-0f5f93, #0f5f93)',
  floatingSurface: 'var(--venue-conductor-floating-surface, rgba(255, 255, 255, 0.92))',
  floatingSurfaceStrong: 'var(--venue-conductor-floating-surface-strong, rgba(255, 255, 255, 0.94))',
  voiceStageBackground: 'var(--venue-conductor-voice-stage-bg, linear-gradient(180deg, #f8fafc 0%, #ffffff 100%))',
  voiceOrbBackground: 'var(--venue-conductor-voice-orb-bg, var(--od-c-ffffff, #ffffff))',
  voiceOrbBorder: 'var(--venue-conductor-voice-orb-border, var(--od-c-dbe4ef, #dbe4ef))',
  voiceOrbShadow: 'var(--venue-conductor-voice-orb-shadow, 0 22px 55px rgba(15, 23, 42, 0.16), inset 0 0 0 18px rgba(248, 250, 252, 0.92))',
  voiceOrbCompactShadow: 'var(--venue-conductor-voice-orb-compact-shadow, 0 10px 24px rgba(15, 23, 42, 0.12), inset 0 0 0 8px rgba(248, 250, 252, 0.92))',
  voiceOrbActiveBackground: 'var(--venue-conductor-voice-orb-active-bg, radial-gradient(circle at 34% 28%, #fff7ed 0%, #fee2e2 38%, var(--od-c-ffffff, #ffffff) 72%))',
  voiceOrbActiveBorder: 'var(--venue-conductor-voice-orb-active-border, #fecaca)',
  voiceOrbPausedBackground: 'var(--venue-conductor-voice-orb-paused-bg, radial-gradient(circle at 34% 28%, var(--od-c-eff6ff, #eff6ff) 0%, #dbeafe 36%, var(--od-c-ffffff, #ffffff) 74%))',
  voiceOrbInnerSurface: 'var(--venue-conductor-voice-orb-inner-surface, var(--venue-conductor-floating-surface, rgba(255, 255, 255, 0.92)))',
  voiceOrbInnerBorder: 'var(--venue-conductor-voice-orb-inner-border, var(--od-c-cbd5e1, #cbd5e1))',
  voiceOrbIcon: 'var(--venue-conductor-voice-orb-icon, #991b1b)',
  voiceOrbPausedIcon: 'var(--venue-conductor-voice-orb-paused-icon, #1d4ed8)',
  voiceOrbInnerShadow: 'var(--venue-conductor-voice-orb-inner-shadow, inset 0 0 18px rgba(15, 23, 42, 0.06))',
  voiceOrbPrimaryRing: 'var(--venue-conductor-voice-orb-primary-ring, rgba(185, 28, 28, 0.24))',
  voiceOrbSecondaryRing: 'var(--venue-conductor-voice-orb-secondary-ring, rgba(15, 118, 110, 0.22))',
  // Brand coral (matches the launch video — C_RED #FF595E). Paired with white.
  brandCoral: 'var(--venue-conductor-brand-coral, #FF595E)',
  brandCoralGradient: 'var(--venue-conductor-brand-coral-gradient, linear-gradient(135deg, #FF595E 0%, #ef464c 100%))',
  brandCoralBorder: 'var(--venue-conductor-brand-coral-border, rgba(255, 89, 94, 0.45))',
  brandCoralShadow: 'var(--venue-conductor-brand-coral-shadow, rgba(255, 89, 94, 0.32))'
};
